export function useActiveSection(ids: MaybeRefOrGetter<string[]>) {
  const active = ref(toValue(ids)[0] ?? '')
  let io: IntersectionObserver | null = null

  function observeSections(nextIds: string[]) {
    io?.disconnect()
    io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) active.value = entry.target.id
      })
    }, { rootMargin: '-45% 0px -50% 0px' })

    nextIds.forEach(id => {
      const el = document.getElementById(id)
      if (el) io?.observe(el)
    })
  }

  onMounted(() => {
    watch(
      () => toValue(ids),
      (nextIds) => {
        if (!nextIds.includes(active.value)) active.value = nextIds[0] ?? ''
        observeSections(nextIds)
      },
      { immediate: true }
    )
  })

  onBeforeUnmount(() => io?.disconnect())
  const go = (id: string) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  return { active, go }
}
